$(document).ready(function () {
  // The quiz is scrolled into view when it lives in the page. When it has been
  // moved into the sizing quiz modal there is nothing to scroll to, so these
  // animations are skipped. See assets/size-quiz-modal.js.
  function quizInModal() {
    return document.body.classList.contains('size-quiz-modal-open');
  }

  function scrollToQuiz(duration) {
    if (quizInModal()) return;
    var quizSection = $("#shopify-section-quiz-section").offset();
    if (!quizSection) return;
    $('html, body').animate({ scrollTop: quizSection.top - 50 }, duration);
  }
  $('#view-results').on('click', function(e) {
    e.preventDefault();
    //window.location.href="https://www.littlechonk.com/products/copy-of-the-maxine-one%E2%84%A2-bag-2";
      $("html, body").animate({ scrollTop: 0 }, "slow");
      return false;
      
  });

  $('.close-quiz').on('click', function(e){
    e.preventDefault();
    // In modal mode size-quiz-modal.js owns closing (and un-revealing) the quiz.
    if (quizInModal()) return;
    $('.take-quiz').removeClass('hide');
    $('#shopify-section-quiz-section').removeClass('reveal');
  });
  $('.take-quiz, .pro-svg-images').on('click', function(e) {
    e.preventDefault();
    // On products that use the sizing quiz modal, .pro-svg-images no longer
    // scrolls the customer down to the in-page quiz — the "Size Up Your Pup"
    // button opens the modal instead. See assets/size-quiz-modal.js.
    if ($(this).hasClass('pro-svg-images') && document.body.classList.contains('size-quiz-modal-enabled')) {
      return;
    }
    $(this).addClass('hide');
    $('#shopify-section-quiz-section').addClass('reveal');
    scrollToQuiz(100);
    });
  
    // hidden things
    $(".form-business").hide();
    $("#successMessage").hide();
    // next button 
		
		
  // ---- Sizing quiz recommendation ---------------------------------------
  // Answer values:
  //   weight (.qqw): w15 = up to 15 lbs | w25 = 15-25 lbs | w50 = 25-50 lbs | w50plus = 50+ lbs
  //   back   (.qq2): b9_12 | b14_19 | b22_25 | b26_28 | other
  //   girth  (.qq3): g15_20 | g20_25 | g25_30 | g30_36 | other
  // Product limits used below:
  //   The Tiny One  - up to 15 lbs, back up to 12", girth up to 25"
  //   Maxine One S  - up to 25 lbs      Maxine One M - up to 50 lbs
  //   Brodie One    - 40-100 lbs
  var qqw, qq2, qq3;

  // Back length + girth only (the original quiz rules, mapped to the new girth options).
  function sizeByMeasurements(back, girth) {
    var gS = girth === 'g15_20';
    var gM = girth === 'g20_25' || girth === 'g25_30';
    var gL = girth === 'g30_36';
    if (back === 'b9_12' && gS) return 'm1s';                                    // Maxine One Small
    if ((back === 'b9_12' && gM) || (back === 'b14_19' && (gS || gM))) return 'm1'; // Maxine One Medium
    if (back === 'b22_25' && (gM || gL)) return 'b1s';                             // Brodie One Large
    if (back === 'b26_28' && (gM || gL)) return 'b1';                              // Brodie One XL
    return 'other';
  }

  function recommendSize(weight, back, girth) {
    if (!weight || !back || !girth || back === 'other' || girth === 'other') return 'other';

    // Up to 15 lbs AND short AND slim enough -> The Tiny One.
    // (A 15 lb dog that is too long or too wide falls through to the Maxine rules below.)
    if (weight === 'w15' && back === 'b9_12' && (girth === 'g15_20' || girth === 'g20_25')) {
      return 'tiny';
    }

    // 50+ lbs -> Brodie One. Back length + girth pick Large vs XL.
    // Dogs shorter than 22" get Brodie Large with a "may be roomy" caution.
    if (weight === 'w50plus') {
      if (back === 'b22_25' || back === 'b26_28') return sizeByMeasurements(back, girth);
      return 'b1s-short';
    }

    // 15-50 lbs: back length + girth decide.
    var size = sizeByMeasurements(back, girth);
    // Maxine One Small is rated up to 25 lbs, so heavier dogs move up to Medium.
    if (size === 'm1s' && weight === 'w50') size = 'm1';
    return size;
  }

  function showResult(size) {
    console.log('Sizing quiz result: ' + size);
    $('.size-tiny-message, .size-m1s-message, .size-m1-message, .size-b1s-message, .size-b1-message, .size-b1s-short-message, .size-other-message').removeClass('active');
    $('.size-' + size + '-message').addClass('active');
  }

    $(".quiz-next").on({
        click: function () {
          qqw = $(".qqw input:checked").val();
          qq2 = $(".qq2 input:checked").val();
          qq3 = $(".qq3 input:checked").val();
          showResult(recommendSize(qqw, qq2, qq3));
          

          
          /*if (qq2 == 'size-m1' && qq3 == 'size-m1') {
           // window.location.href = "https://www.littlechonk.com/products/copy-of-the-maxine-one%E2%84%A2-bag-2?variant=43491526738134";
            //window.location.href = "https://www.littlechonk.com/products/copy-of-the-maxine-one%E2%84%A2-bag-2?variant=43491526705366";
            $('.size-m1-message').addClass('active');
            $('.size-m1s-message').removeClass('active');
            $('.size-other-message').removeClass('active');
          } else if (qq2 == 'size-m1' && qq3 == 'size-m1s') {
            //window.location.href = "https://www.littlechonk.com/products/copy-of-the-maxine-one%E2%84%A2-bag-2?variant=43491526738134";
            //window.location.href = "https://www.littlechonk.com/products/copy-of-the-maxine-one%E2%84%A2-bag-2?variant=43491526705366";
            $('.size-m1-message').addClass('active');
            $('.size-m1s-message').removeClass('active');
            $('.size-other-message').removeClass('active');
          } else if (qq2 == 'size-m1s' && qq3 == 'size-m1') {
            //window.location.href = "https://www.littlechonk.com/products/copy-of-the-maxine-one%E2%84%A2-bag-2?variant=43491526738134";
            //window.location.href = "https://www.littlechonk.com/products/copy-of-the-maxine-one%E2%84%A2-bag-2?variant=43491526705366";
            $('.size-m1-message').removeClass('active');
            $('.size-m1s-message').addClass('active');
            $('.size-other-message').removeClass('active');
          } else if (qq2 == 'size-m1s' && qq3 == 'size-m1s') {
            //window.location.href = "https://www.littlechonk.com/products/copy-of-the-maxine-one%E2%84%A2-bag-2?variant=43491526738134";
            //window.location.href = "https://www.littlechonk.com/products/copy-of-the-maxine-one%E2%84%A2-bag-2?variant=43491526705366";
            $('.size-m1-message').removeClass('active');
            $('.size-m1s-message').addClass('active');
            $('.size-other-message').removeClass('active');
          } else if (qq2 == 'other' || qq3 == 'other') {
            //window.location.href = "https://www.littlechonk.com/products/copy-of-the-maxine-one%E2%84%A2-bag-2?variant=43491526738134";
            //window.location.href = "https://www.littlechonk.com/products/copy-of-the-maxine-one%E2%84%A2-bag-2?variant=43491526705366";
            $('.size-m1-message').removeClass('active');
            $('.size-m1s-message').removeClass('active');
            $('.size-other-message').addClass('active');
          }*/
/*


						 optionA = $("input[data-val1='A']:checked").length;
						 optionB = $("input[data-val2='B']:checked").length;
						 optionC = $("input[data-val3='C']:checked").length;
						 optionD = $("input[data-val4='D']:checked").length;
						 optionE = $("input[data-val5='E']:checked").length;
						 optionF = $("input[data-val6='F']:checked").length;

          
						console.log('option A:'+optionA);
						console.log('option B:'+optionB);
						console.log('option C:'+optionC);
						console.log('option D:'+optionD);
						console.log('option E:'+optionE);
						console.log('option F:'+optionF);
						
						$('.optionA').text(optionA);
						$('.optionB').text(optionB);
						$('.optionC').text(optionC);
						$('.optionD').text(optionD);
						$('.optionE').text(optionE);
						$('.optionF').text(optionF);*/

              
            var getValue = $(this).parents(".row").find(".option-block").hasClass("active-option");          
            var getValue2 = $(this).hasClass('confirm');
            var getSizeTypeCm = $('input#q1a1');
            var getSizeTypeIn = $('input#q1a2');
          
            if ((getSizeTypeIn).is(':checked')) {
              $('.qq2, .qq3, .qqw').removeClass('cm-active').addClass('in-active');
            }
            if ((getSizeTypeCm).is(':checked')) {
              $('.qq2, .qq3, .qqw').removeClass('in-active').addClass('cm-active');
            }
            if (getValue2) {
              scrollToQuiz(100);
            }

          
            if (getValue) {
                $("#progressBar").find(".active").next().addClass("active");
								$("#progressBar").find(".active").prev().addClass("valid");
                $("#alertBox").addClass("d-none");
                $(this).parents(".row").fadeOut(function () {
                    $(this).next(".row").fadeIn();
                });
                $(this).removeClass('notValid');						
            } else {
							$(this).addClass('notValid');
                            scrollToQuiz(100);
               $("#alertBox").removeClass("d-none");							 
            }
        }
    });
    // back button
    $(".back").on({
        click: function () {
            $("#progressBar .active").last().removeClass("active").removeClass('valid');
            $(this).parents(".row").fadeOut("slow", function () {
                $(this).prev(".row").fadeIn("slow");
            });
        }
    });
  
    //finish button
  /*
    $(".submit-button").on({
        click: function () {          
            //$("#wizardRow").fadeOut(300);
            //$(this).parents(".row").children("#successForm").fadeOut(300);

          if (optionA > optionB && optionA > optionC && optionA > optionD && optionA > optionE && optionA > optionF) {
            window.location.href = "WEB";
            var setProfile = "bookworm";
          }

          else if (optionB > optionA && optionB > optionC && optionB > optionD && optionB > optionE && optionB > optionF) {
            window.location.href = "ADD";
            var setProfile = "crisp-classic";
          }  

          $("#successMessage").fadeIn(3000);

        }
     
    });*/
            

		
    $(".option-block").on({
        click: function (e) {
				
					var limit = $(this).parent('.options-container');
						
						if (limit.hasClass('limit2')) {
							var check = $('.limit2').find('input[type=checkbox]:checked').length;
							console.log(check);
							if (check > 2) {
								$('.only2options').removeClass('d-none');								
								$('.limit2 .option-block').not('.active-option').addClass('disabled');
							}
							if (check <= 2) {								
								$('.only2options').addClass('d-none');								
								$('.limit2 .disabled').removeClass('disabled');
							}							
						}					
				 
						var qType = $(this).find('input');						
						qType.prop('checked');
			
						if (qType.is(':radio')) {							
							$(this).parent(".options-container").children(".option-block").siblings().removeClass("active-option");				
							$(this).addClass("active-option");
							
						} 
						
						if (qType.is(':checkbox')) {												
							if(qType.is(':checked')){
								if ($(this).hasClass('disabled')){
									e.preventDefault();
								} else {
								$(this).addClass("active-option");
								}
								
							}else{
							 $(this).removeClass("active-option");
							}
						}
									
									
						
						
					
				
            //$(this).parent(".options-container").children(".option-block").siblings().removeClass("active-option");				
            //$(this).addClass("active-option");
        }
    });
    //back to wizard
    $(".back-to-wizard").on({
        click: function () {
            location.reload(true);
        }
    });
});